/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation CBRRoutePlanDeleteManyMutation($routePlanIds: [ID!] !) {
    CBRRoutePlanDeleteMany(routePlanIds: $routePlanIds){
      message
      status
    }
  }
`

